<template>
  <div class="profile_region">
    <main class="main" role="main">
      <div class="main_con">
        <h1 class="pr_nickname">
          {{ userProfile.nickname }}님<br />방갑습니다 :)
        </h1>
        <div class="pr_img">
          <img src="@/assets/front/images/new/img_login_fini.png" alt="" />
        </div>
        <div class="pr_region">
          <div class="ttl_section" v-if="this.loginMethod != 'kakao'">
            <div class="top_ttl">성별이 어떻게 되시나요?</div>
            <div class="sec_item">
              <label
                v-for="(item, index) in userGender"
                :key="index"
                class="pnt"
              >
                <input
                  type="radio"
                  name="gender"
                  :value="item.value"
                  v-model="gender"
                />
                <div class="txt"></div>
                <div class="txt02" :title="item.label">{{ item.label }}</div>
              </label>
            </div>
          </div>
          <div class="top_divider" v-if="this.loginMethod != 'kakao'"></div>
          <div class="ttl_section" v-if="this.loginMethod != 'kakao'">
            <div class="top_ttl">연령대가 어떻게 되시나요?</div>
            <div class="sec_item">
              <label
                v-for="(item, index) in userAgeRange"
                :key="index"
                class="pnt"
              >
                <input
                  type="radio"
                  name="age"
                  :value="item.value"
                  v-model="ageRange"
                />
                <div class="txt"></div>
                <div class="txt02" :title="item.label">{{ item.label }}</div>
              </label>
            </div>
          </div>
          <div class="top_divider" v-if="this.loginMethod != 'kakao'"></div>
          <div class="ttl_section">
            <div class="top_ttl">우리동네 설정하기!</div>
            <div class="area_sel_wrap" v-if="areaInfo.areaId">
              <div class="area_txt">선택동네: {{ areaInfo.areaFullName }}</div>
              <div class="area_img" @click="areaDel">
                <img
                  :src="
                    require('@/assets/front/images/new/i_x_n_dark_green.svg')
                  "
                />
              </div>
            </div>
            <label class="search" style="margin-bottom: 1.6rem;">
              <input
                type="search"
                v-model="searchText"
                placeholder="동, 읍, 면 단위로 검색"
                @keyup.enter="getRegionByName"
              />
              <button class="i_search" @click="getRegionByName"></button>
            </label>
          </div>
          <div
            @click="getCurrentRegion"
            style="align-items: center;justify-content: center;display:flex;"
            :style="
              geolocationAvailable === true
                ? 'font-size: 1.3rem;\n' +
                  'font-weight: 700;\n' +
                  'color: #50d3b4;'
                : 'color: #50d3b4;\n' +
                  'font-weight: 700;\n' +
                  'font-size: 1.3rem;\n' +
                  'cursor: default;'
            "
          >
            <!-- <img
              v-if="geolocationAvailable === false"
              :src="
                require('@/assets/front/images/new/i_location_input_gray.svg')
              "
              style="width:1.8rem;height:1.8rem;margin-right:0.4rem;"
              alt=""
            />
            <img
              v-if="geolocationAvailable === true"
              :src="
                require('@/assets/front/images/new/i_location_input_green.svg')
              "
              style="width:1.8rem;height:1.8rem;margin-right:0.4rem;"
              alt=""
            /> -->
            <img
              :src="
                require('@/assets/front/images/new/i_location_input_green.svg')
              "
              style="width:1.8rem;height:1.8rem;margin-right:0.4rem;"
              alt=""
            />
            현재 위치 불러오기
          </div>
          <div class="top_divider"></div>
        </div>

        <div class="pr_result">
          <div v-if="showCurrentRegion">
            <div class="location_list" v-if="myArea.nearby.length">
              <div class="location_ttl">우리동네</div>
              <ul>
                <li>
                  <div
                    role="button"
                    @click="selectRegion(myArea.current, fromPage)"
                  >
                    {{ myArea.current.name }}
                  </div>
                </li>
              </ul>
              <div class="location_ttl">근처동네</div>
              <ul>
                <li v-for="(item, index) in myArea.nearby" v-bind:key="index">
                  <div role="button" @click="selectRegion(item, fromPage)">
                    {{ item.name }}
                  </div>
                </li>
              </ul>
            </div>
            <div class="empty_wrap" v-if="myArea.nearby.length == 0">
              <div class="empty result">
                <!--'기본: ', '준비중: ready', '결과없음: result'-->
                <div class="msg">
                  <div>현재 위치로 정보를 받아오지 못했습니다.</div>
                  <div>우리동네 이름으로 검색해보세요.</div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="showSearchResult">
            <div class="location_list" v-if="area.count">
              <div class="location_ttl">검색결과</div>
              <ul>
                <ul>
                  <li v-for="(item, index) in area.content" v-bind:key="index">
                    <div role="button" @click="selectRegion(item, fromPage)">
                      {{ item.name }}
                    </div>
                  </li>
                </ul>
              </ul>
            </div>
            <div class="empty_wrap" v-if="area.count == 0">
              <div class="empty result">
                <!--'기본: ', '준비중: ready', '결과없음: result'-->
                <div class="msg">
                  <div>검색하신 동네가 없습니다.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btm_btn">
        <div class="btn_wrap">
          <button class="btn" @click="joinUpdate">
            가입 완료
          </button>
        </div>
      </div>
      <transition name="fade">
        <div
          class="made_toast_layer_common"
          style="bottom:7rem;"
          v-if="isViewToast"
        >
          <div class="toast_msg">{{ errorMessage }}</div>
        </div>
      </transition>
    </main>
    <GPSUseConfirmModal
      v-if="gpsUseModal"
      @close="hideGpsUseModal"
      @setting="openSetting"
    ></GPSUseConfirmModal>
    <GPSOffModal
      v-if="gpsOffModal"
      @close="hideGpsOffModal"
      @setting="openSetting"
    ></GPSOffModal>
  </div>
</template>

<script>
import GPSUseConfirmModal from '@/front/customer/views/auth/modal/GPSUseConfirmModal';
import GPSOffModal from '@/front/customer/views/auth/modal/GPSOffModal';
import { mapActions, mapState, mapGetters } from '@common/store/modules/area';
import * as actions from '@common/store/modules/area/types';
import * as getters from '@common/store/modules/area/getters';
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';
import {
  mapActions as mapXeronoteActions,
  mapGetters as mapXeronoteGetters,
} from '@common/store/modules/xeronote';
import * as xeronoteTypes from '@common/store/modules/xeronote/types';
import {
  isApp,
  sleep,
  clearLocation,
  nativeLocation,
  nativeGoToSetting,
  nativeEnableBackKey,
  nativeDisableBackKey,
  nativeDeviceInfo,
} from '@common/lib/common/utils';

export default {
  components: { GPSOffModal, GPSUseConfirmModal },
  async created() {
    nativeDisableBackKey();
    this.loginMethod = this.$route.query.loginMethod;
    await this.handleLocation();
    await this.fetchMe();
    console.log('this.userProfile');
    console.log(this.userProfile.nickname);
    if (!this.userProfile.nickname || this.userProfile.nickname == null) {
      await this.setNickname();
    }
    await this.handleRefresh();
  },
  data() {
    return {
      isFirst: true,
      gpsUseModal: false,
      gpsOffModal: false,
      checkerId: -1,
      latitude: 0,
      longitude: 0,

      fromPage: 'Auth',
      lat: 0,
      lng: 0,
      searchText: '',
      showSearchResult: false,
      showCurrentRegion: false,
      geolocationAvailable: false,
      // userProfile: {},
      userGender: [
        { label: '남성', value: 'MALE' },
        { label: '여성', value: 'FEMALE' },
      ],
      userAgeRange: [
        { label: '10대', value: 'AGE_15_19' },
        { label: '20대', value: 'AGE_20_29' },
        { label: '30대', value: 'AGE_30_39' },
        { label: '40대', value: 'AGE_40_49' },
        { label: '50대', value: 'AGE_50_59' },
        { label: '60대', value: 'AGE_60_69' },
        { label: '70대 이상', value: 'AGE_70_ABOVE' },
      ],
      gender: '',
      ageRange: '',
      areaInfo: {
        areaId: '',
        areaName: '',
        areaFullName: '',
        codeType: '',
      },
      isViewToast: false,
      errorMessage: '',
      loginMethod: 'mobile',
    };
  },
  computed: {
    ...userMapGetters({
      userProfile: userTypes.USER,
    }),
    ...mapGetters({
      myArea: getters.MY_AREA,
      area: getters.AREA,
    }),
    ...mapXeronoteGetters({
      nicknameList: xeronoteTypes.NICKNAME,
    }),
  },
  beforeDestroy() {
    if (this.checkerId !== -1) {
      clearInterval(this.checkerId);
      this.checkerId = -1;
    }
  },
  methods: {
    ...userMapActions([
      userTypes.FETCH_ME,
      userTypes.UPDATE_AREA_ME,
      userTypes.UPDATE_USER_DATA,
      userTypes.UPDATE_NICKNAME,
      userTypes.UPDATE_USER_TELECOM_AND_DEVICE,
    ]),
    ...mapActions([
      actions.FETCH_CURRENT,
      actions.FETCH_DONG,
      actions.AREA_RESET_STATE,
    ]),
    ...mapXeronoteActions([xeronoteTypes.FETCH_NICKNAME]),
    async fetchMe() {
      await this[userTypes.FETCH_ME]();
    },
    async setNickname() {
      await this[xeronoteTypes.FETCH_NICKNAME]();
      console.log(this.nicknameList.content[0].nickname);

      const params = {
        nickname: this.nicknameList.content[0].nickname,
      };
      console.log(params);
      await this[userTypes.UPDATE_NICKNAME](params);
    },
    startChecker() {
      if (this.checkerId === -1) {
        this.checkerId = setInterval(() => {
          if (window.$bridge.location.code === '1') {
            this.hideGpsOffModal();
            this.hideGpsUseModal();
          }
        }, 1000);
      }
    },
    hideGpsUseModal() {
      this.gpsUseModal = false;
      if (this.checkerId !== -1) {
        clearInterval(this.checkerId);
        this.checkerId = -1;
      }
    },
    hideGpsOffModal() {
      this.gpsOffModal = false;
      if (this.checkerId !== -1) {
        clearInterval(this.checkerId);
        this.checkerId = -1;
      }
    },
    showGpsUseModal() {
      this.gpsUseModal = true;
      if (this.checkerId === -1) {
        this.startChecker();
      }
    },
    showGpsOffModal() {
      this.gpsOffModal = true;
      if (this.checkerId === -1) {
        this.startChecker();
      }
    },
    openSetting() {
      if (!isApp()) {
        this.getLocation();
      } else {
        // 네이티브 앱 위치설정 열기
        nativeGoToSetting(2);
      }
    },
    // 위치정보 확인 후 동네설정으로 이동
    gotoRegionSetting() {
      this.handleLocation();
    },
    async handleLocation() {
      // 앱이 아닌 경우
      if (!isApp()) {
        navigator.permissions
          .query({ name: 'geolocation' })
          .then(permissionStatus => {
            console.log(permissionStatus.state.toString());

            switch (permissionStatus.state.toString()) {
              case 'prompt':
                if (!this.isFirst) this.showGpsUseModal();
                break;
              case 'denied':
                if (!this.isFirst) this.showGpsOffModal();
                break;
              case 'granted':
                if (!this.isFirst) this.$router.push({ name: 'Auth.Region' });
                break;
              default:
                //this.$router.push({ name: 'Auth.Region' });
                break;
            }

            this.isFirst = false;
          });
      }
      // 앱인 경우
      else {
        clearLocation();
        nativeLocation();
        await sleep(1000);
        if (window.$bridge.location.code !== undefined) {
          // GPS 켜져있을때 : 1, 꺼져있을 때 -1
          if (window.$bridge.location.code === '1') {
            this.hideGpsOffModal();
            this.hideGpsUseModal();
            if (!this.isFirst) await this.$router.push({ name: 'Auth.Region' });
          } else {
            this.showGpsOffModal();
          }
          this.isFirst = false;
        } else {
          if (!this.isFirst) this.showGpsUseModal();
          this.isFirst = false;
        }
      }
    },

    getLocation() {
      if (navigator.geolocation) {
        return new Promise(() => {
          navigator.geolocation.getCurrentPosition(
            this.showPosition,
            this.showError,
          );
        });
      } else {
        console.log('Geolocation is not supported by this browser.');
      }
    },

    showPosition(position) {
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
    },

    showError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          console.log('User denied the request for Geolocation.');
          break;
        case error.POSITION_UNAVAILABLE:
          console.log('Location information is unavailable.');
          break;
        case error.TIMEOUT:
          console.log('The request to get user location timed out.');
          break;
        case error.UNKNOWN_ERROR:
          console.log('An unknown error occurred.');
          break;
      }
    },
    async getRegionByName() {
      this[actions.AREA_RESET_STATE]();
      this.showCurrentRegion = false;
      this.showSearchResult = true;
      const param = {
        keyword: this.searchText,
      };
      if (param.keyword) {
        await this[actions.FETCH_DONG](param);
      }
    },
    async getCurrentRegion() {
      await this.handleRefresh();
      if (this.geolocationAvailable) {
        this[actions.AREA_RESET_STATE]();
        this.showSearchResult = false;
        this.showCurrentRegion = true;
        const param = {
          distance: 2000,
          latitude: this.lat,
          longitude: this.lng,
        };
        await this[actions.FETCH_CURRENT](param);
      }
    },
    async handleRefresh() {
      if (!isApp()) {
        if (this.$geolocation.checkSupport()) {
          const currentPosition = await this.$geolocation.getCurrentPosition();
          if (currentPosition) {
            console.log(currentPosition);
            this.lat = currentPosition.coords.latitude;
            this.lng = currentPosition.coords.longitude;
            this.geolocationAvailable = true;
          }
        }
      } else {
        clearLocation();
        nativeLocation();
        await sleep(1000);
        //alert('location.code: ' + window.$bridge.location.code);
        if (window.$bridge.location.code !== undefined) {
          // GPS 켜져있을때 : 1, 꺼져있을 때 -1
          if (window.$bridge.location.code === '1') {
            //alert('a1');
            this.hideGpsOffModal();
            this.hideGpsUseModal();
            this.lat = window.$bridge.location.latitude;
            this.lng = window.$bridge.location.longitude;
            this.geolocationAvailable = true;
          } else {
            //alert('a2');
            /*this[commonActions.SET_DIALOG]({
              type: 'normal',
              icon: 'warning',
              //title: this.$t('common.confirm'),
              message: `GPS가 꺼져있습니다.`,
              okCb: async () => {
                this[commonActions.HIDE_DIALOG]();
              },
            });*/

            this.showGpsOffModal();
          }
        } else {
          //alert('a3');
          /*this[commonActions.SET_DIALOG]({
            type: 'normal',
            icon: 'warning',
            //title: this.$t('common.confirm'),
            message: '위치 권한이 없습니다.',
            okCb: async () => {
              this[commonActions.HIDE_DIALOG]();
            },
          });*/
          this.showGpsUseModal();
        }
      }
    },
    selectRegion(area, fromPage) {
      const { id, name, emd_name, codeType } = area;

      this.areaInfo.areaId = id;
      this.areaInfo.areaName = emd_name;
      this.areaInfo.areaFullName = name;
      this.areaInfo.codeType = codeType;
    },
    async joinUpdate() {
      if (this.loginMethod != 'kakao') {
        if (this.gender === '') {
          this.errorMessage = '성별을 선택해주세요';
          this.toastView();
          return false;
        }

        if (this.ageRange === '') {
          this.errorMessage = '연령대를 선택해주세요';
          this.toastView();
          return false;
        }
      }

      if (this.areaInfo.areaId === '') {
        this.errorMessage = '동네를 선택해주세요';
        this.toastView();
        return false;
      }

      console.log(this.areaInfo);

      await this.getDevice();

      if (this.loginMethod == 'kakao') {
        // 동네 정보 저장후 우리동네 매장 페이지로 이동
        const payload = this.areaInfo;
        //console.log(payload);

        this[userTypes.UPDATE_AREA_ME](payload).then(() => {
          this.$router.push({ name: 'Home' });
        });
      } else {
        // 동네 정보 저장후 우리동네 매장 페이지로 이동
        const payload = {
          gender: this.gender,
          ageRange: this.ageRange,
          areaInfo: this.areaInfo,
        };
        console.log(payload);

        this[userTypes.UPDATE_USER_DATA](payload).then(() => {
          this.$router.push({ name: 'Home' });
        });
      }
    },
    async getDevice() {
      nativeDeviceInfo();
      await sleep(800);
      const myDeviceName = window.$bridge.deviceModelName || '';
      const myTelecomName = window.$bridge.telecomName || '';

      if (this.myDeviceName != '' || this.myTelecomName != '') {
        let td_param = {
          id: this.userProfile.id,
          deviceName: myDeviceName,
          deviceModelName: '',
          telecomName: myTelecomName,
        };

        console.log('td_paramvtd_paramtd_paramtd_param');
        console.log(td_param);

        this[userTypes.UPDATE_USER_TELECOM_AND_DEVICE](td_param);
      }
    },
    areaDel() {
      this.areaInfo.areaId = '';
      this.areaInfo.areaName = '';
      this.areaInfo.areaFullName = '';
      this.areaInfo.codeType = '';
    },
    toastView() {
      this.isViewToast = true;
      setTimeout(() => {
        this.isViewToast = false;
      }, 2000);
    },
  },
};
</script>
